import React from 'react';
import { connect } from 'react-redux';
import { getPurchase, resetInstallmentsPlan, resetPaymentCardError } from '@/actions/purchase';
import { cybersourcePaymentAttempt } from '@/actions/payment';
import { clearError } from '@/actions';
import MobileCybersourcePayment from './MobileCybersourcePayment';
import MobilePaymentBase from '../MobilePaymentBase/MobilePaymentBase';

const mapStateToProps = (state, ownProps) => {
  const { purchase, payment, errors } = state;
  const purchaseJs = purchase.toJS();
  const { token } = ownProps.match.params;

  return {
    env: state.whitelabelConfig.env,
    errors,
    cardErrorOccured: payment.get('cardErrorOccured'),
    fetchingPayment: payment.get('isFetching') || false,
    paymentId: payment.get('id'),
    purchase: purchaseJs,
    token,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { token } = ownProps.match.params;

  return {
    getPurchase: () => dispatch(getPurchase(token)),
    onCybersourcePaymentAttempt: (paymentData) => dispatch(cybersourcePaymentAttempt(paymentData)),
    resetInstallmentsPlan: () => dispatch(resetInstallmentsPlan()),
    resetPaymentCardError: () => dispatch(resetPaymentCardError()),
    transitionTo: (route) => ownProps.history.push(route),
    clearErrors: () => dispatch(clearError()),
  };
};

/**
 * Combina las props del estado, acciones y props del componente
 * @param {Object} stateProps - Props del estado de Redux
 * @param {Object} dispatchProps - Props de acciones de Redux
 * @param {Object} ownProps - Props propias del componente
 * @returns {Object} Props combinadas
 */
const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

const ConnectedMobileCybersourcePayment = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)((props) => (
  <MobilePaymentBase {...props}>
    {(mobilePaymentProps) => <MobileCybersourcePayment {...mobilePaymentProps} />}
  </MobilePaymentBase>
));

export default ConnectedMobileCybersourcePayment;
